import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./Routes";
import '@fortawesome/fontawesome-free/css/all.min.css';
import Footer from "./components/footer/Footer";
import NavigationBar from "./components/navigation/NavigationBar";
import Cookies from "js-cookie";
import {
  JWT_TOKEN,
  REFRESH_TOKEN,
  getLoginUrlWithRedirect,
} from "./constants/Constants";
import {
  cookiesCleanup,
  saveRefreshToken,
  saveUserInfo,
  saveUserToken,
} from "./utils/AuthUtils";
import { ssoRefreshToken } from "./services/AuthService";
import { UserProvider } from "./context/UserContext";
import { encodeUserInfo } from "./utils/userInfoEncoding";

// Everything inside <Router>: reads the shared-domain JWT cookie and gates the
// whole site. No token -> redirect to the central auth portal.
function AuthenticatedApp() {
  const jwtToken = Cookies.get(JWT_TOKEN);

  useEffect(() => {
    getAccessTokenSilently();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAccessTokenSilently = async () => {
    if (jwtToken) {
      return; // token already present
    }

    const refreshToken = Cookies.get(REFRESH_TOKEN);
    if (!refreshToken) {
      cookiesCleanup();
      window.location.href = getLoginUrlWithRedirect();
      return;
    }

    try {
      const data = await ssoRefreshToken({ refreshToken });
      if (data?.status === 0) {
        saveUserToken(data?.accessToken, data?.expiresAt);
        saveRefreshToken(data?.refreshToken, data?.refreshTokenExpiresAt);

        const infoPayload = {
          applications: data?.applications,
          operatorId: data?.operatorId,
          name: data?.name,
          location: data?.location,
        };
        saveUserInfo(encodeUserInfo(infoPayload));
        window.location.reload();
      } else {
        cookiesCleanup();
        window.location.href = getLoginUrlWithRedirect();
      }
    } catch (err) {
      cookiesCleanup();
      window.location.href = getLoginUrlWithRedirect();
    }
  };

  if (!jwtToken) {
    // Portal redirect / silent refresh in flight — render nothing.
    return null;
  }

  return (
    <UserProvider>
      <NavigationBar />
      <AppRoutes />
      <Footer />
    </UserProvider>
  );
}

function App() {
  return (
    <Router>
      <AuthenticatedApp />
    </Router>
  );
}

export default App;
